import { toSafeString } from '@shared/utils';
import { extractChecklistUpdateResultActiveChecklist, normalizeActiveChecklist } from '@/lib/threadChecklist.js';
import { NON_RUNNING_RUN_STATES } from '@/lib/pieveRunState.js';
import getInteractionRunId from '@/lib/threadInteractions/getInteractionRunId.js';

const resolveThreadActiveChecklist = ({ activity = [], threadMeta = null, runState = null, activeRunId = null } = {}) => {
  const normalizedActivity = Array.isArray(activity) ? activity : [];
  const hasCanonicalChecklistField = Boolean(threadMeta && typeof threadMeta === 'object' && !Array.isArray(threadMeta) && (Object.prototype.hasOwnProperty.call(threadMeta, 'activeChecklist') || Object.prototype.hasOwnProperty.call(threadMeta, 'active_checklist')));
  const normalizedMetaChecklist = normalizeActiveChecklist(threadMeta?.activeChecklist || threadMeta?.active_checklist);
  const normalizedRunState = String(runState || '')
    .trim()
    .toLowerCase();
  const normalizedActiveRunId = toSafeString(activeRunId);

  if (hasCanonicalChecklistField && NON_RUNNING_RUN_STATES.has(normalizedRunState)) {
    return normalizedMetaChecklist;
  }

  for (let index = normalizedActivity.length - 1; index >= 0; index -= 1) {
    const activityEvent = normalizedActivity[index];
    const eventRunId = toSafeString(getInteractionRunId(activityEvent));

    // Skip checklist updates emitted by a prior, already-terminated run. Once a
    // run ends its checklist is cleared from thread metadata, but the historical
    // checklist_update event stays in the activity feed. Without this guard the
    // backward scan re-surfaces that stale checklist on every later run while the
    // agent is working, so an incomplete checklist keeps reappearing (GRA-18204).
    if (normalizedActiveRunId && eventRunId && eventRunId !== normalizedActiveRunId) {
      continue;
    }

    const checklistUpdateResult = extractChecklistUpdateResultActiveChecklist(activityEvent);

    if (!checklistUpdateResult.hasActiveChecklist) {
      continue;
    }

    return checklistUpdateResult.activeChecklist;
  }

  return normalizedMetaChecklist;
};

export default resolveThreadActiveChecklist;
